import { ButtonC } from 'Common/Buttons';
import { SVG } from 'Common/commonsvg.js';
import { useEffect, useRef, useState, useCallback } from 'react';
import { Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import InputC from 'Common/Inputs/index.tsx';

const ManageButton = ({
  DataStatus,
  isEdited,
  isDraft,
  publishloading,
  loading,
  handlePublish,
  handleDiscardChanges,
  handleUnpublish,
  setSelectTab,
  SelectTab
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDiscardModalOpen, setIsDiscardModalOpen] = useState(false);
  const [unpublishchanges, setUnpublishchanges] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleModal = useCallback((setter) => (event) => {
    event?.stopPropagation();
    setter((prev) => !prev);
  }, []);

  const handleDelete = useCallback(() => {
    handleUnpublish(unpublishchanges);
    setIsDeleteModalOpen(false);
    setSelectTab(0)
  }, [handleUnpublish, unpublishchanges]);

  const handleDiscard = useCallback(() => {
    handleDiscardChanges();
    setIsDiscardModalOpen(false);
  }, [handleDiscardChanges]);

  const handlePublishDisable = useCallback(() => {
    return isEdited ? DataStatus !== 1 : !isEdited;
  }, [isEdited, DataStatus]);
  // const handleSaveDisable = useCallback(() => , [isDraft, isEdited]);
  return (
    <>
      <ButtonC
        text="Save & Publish"
        size="lg"
        click={handlePublish}
        className="me-3"
        disabled={SelectTab === 1 ? true : isEdited ? DataStatus === 1 : isEdited}
      >
        {publishloading && <Spinner color="#e6e6e6" size="sm" className="mx-1" />}
      </ButtonC>
      <ButtonC
        text="Save"
        size="lg"
        className="me-3"
        type="submit"
        disabled={SelectTab === 1 ? true : isEdited}
      >
        {loading && <Spinner color="#e6e6e6" size="sm" className="mx-1 me-3" />}
      </ButtonC>
      <div className="de_threedotdiv" ref={dropdownRef}>
        <div className="de_threedotdiv_container" onClick={() => setIsOpen((prev) => !prev)}>
          {SVG.threedot}
        </div>
        {isOpen && (
          <div className="de_threedotdiv_options">
            <div
              className="de_threedotdiv_items"
              style={{ opacity: DataStatus !== 0 && DataStatus !== 2 ? '100%' : '50%' }}
              onClick={DataStatus !== 0 && DataStatus !== 2 ? toggleModal(setIsDeleteModalOpen) : undefined}
            >
              <span className="option-icon">{SVG.Cross}</span> Unpublish
            </div>
            <div
              className="de_threedotdiv_items"
              style={{ opacity: DataStatus === 3 ? '100%' : '50%' }}
              onClick={DataStatus === 3 ? toggleModal(setIsDiscardModalOpen) : undefined}
            >
              <span className="option-icon">{SVG.Cross}</span> Discard changes
            </div>
          </div>
        )}
      </div>

      {/* Delete Modal */}
      <Modal size="md" isOpen={isDeleteModalOpen} toggle={toggleModal(setIsDeleteModalOpen)} className="Size-adjust">
        <div className="modal-header">
          <h5 className="modal-title">Unpublish Changes</h5>
          <button type="button" className="close" onClick={toggleModal(setIsDeleteModalOpen)}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <ModalBody>
          <h6>Are you sure you want to unpublish the changes?</h6>
          <InputC
            type="radio"
            options={[
              { label: 'Keep draft and remove publish', value: true },
              { label: 'Keep Publish and remove draft.', value: false },
            ]}
            name="unpublish"
            inputvalue={unpublishchanges}
            change={(e) => setUnpublishchanges(e.target.value === 'true')}
          />
        </ModalBody>
        <ModalFooter>
          <button className="large-button Primary-Button" onClick={handleDelete}>Yes</button>
          <button className="large-button Secondary-Button" onClick={toggleModal(setIsDeleteModalOpen)}>No</button>
        </ModalFooter>
      </Modal>

      {/* Discard Modal */}
      <Modal size="md" isOpen={isDiscardModalOpen} toggle={toggleModal(setIsDiscardModalOpen)} className="Size-adjust">
        <div className="modal-header">
          <h5 className="modal-title">Discard Changes</h5>
          <button type="button" className="close" onClick={toggleModal(setIsDiscardModalOpen)}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <ModalBody>
          <h6>Are you sure you want to discard the changes?</h6>
        </ModalBody>
        <ModalFooter>
          <button className="large-button Primary-Button" onClick={handleDiscard}>Yes</button>
          <button className="large-button Secondary-Button" onClick={toggleModal(setIsDiscardModalOpen)}>No</button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ManageButton;